import DOMPurify from "dompurify";

// Allowlist tuned for Quill-produced HTML. Blocks scripts, event handlers,
// javascript: URIs, iframes, forms, etc. by default.
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "hr", "strong", "em", "u", "s", "code", "pre", "blockquote",
    "a", "img", "ul", "ol", "li",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "span", "div", "figure", "figcaption",
  ],
  ALLOWED_ATTR: ["href", "title", "target", "rel", "src", "alt", "class"],
  ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|\/|#)/i,
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "style"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "onblur"],
};

// Force safe rel on any link that opens a new tab
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeHtml(html = "") {
  return DOMPurify.sanitize(html, CONFIG);
}
